export const primaryKeyConfigsPermission = {
    primaryKeyConfigsExtract: "primary-key.get",
    primaryKeyConfigsView: "primary-key-config.get",
    primaryKeyConfigCreate: "primary-key-config.create",
    primaryKeyConfigUpdate: "primary-key-config.update",
    primaryKeyConfigValidate: "primary-key-config.validate",
};
